import type { JsonApiResponse } from '~/interfaces/api/main';
import type { Opportunity } from '~/interfaces/opportunities/main';
import { useAuthFetch } from '~/composables/useAuthFetch';

export interface OpportunitiesListResult {
  items: Opportunity[];
  totalItems: number;
  raw: JsonApiResponse<Opportunity[]>;
}

export interface OpportunityDetailResult {
  item: Opportunity | null;
  raw: JsonApiResponse<Opportunity | null>;
}

const ensureLeadingQuestionMark = (params?: string | null): string => {
  if (!params) {
    return '';
  }
  return params.startsWith('?') ? params : `?${params}`;
};

export const getOpportunitiesList = async (params?: string | null): Promise<OpportunitiesListResult> => {
  const url = `opportunities${ensureLeadingQuestionMark(params)}`;
  const response = await useAuthFetch(url);
  const payload = (response?.data?.value ?? {}) as JsonApiResponse<Opportunity[]>;
  const items = payload.data ?? [];

  return {
    items,
    totalItems: payload.meta?.totalItems ?? items.length,
    raw: payload,
  };
};

export const getOpportunityByHashId = async (hashId: string): Promise<OpportunityDetailResult> => {
  const response = await useAuthFetch(`opportunity/${hashId}`);
  const payload = (response?.data?.value ?? {}) as JsonApiResponse<Opportunity | null>;

  return {
    item: payload.data ?? null,
    raw: payload,
  };
};
